<template>
<div class="classification-wrapper">
  <span class="value-classification" :class="value">&nbsp;</span>
</div>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      return eval('this.item.' + this.column.name)
    }
  }
}
</script>
<style lang="scss">
.value.project_lead-classification{
  text-align: center;
  .value-classification{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// CollectionValueClassification.vue?d74a601c